export default {
  patient: state => state.patient,
  appointment: state => state.appointment
}
